import aws from '../assets/svg/skills/aws.svg'
import bootstrap from '../assets/svg/skills/bootstrap.svg'
import csharp from '../assets/svg/skills/csharp.svg'
import css from '../assets/svg/skills/css.svg'
import django from '../assets/svg/skills/django.svg'
import docker from '../assets/svg/skills/docker.svg'
import firebase from '../assets/svg/skills/firebase.svg'
import gcp from '../assets/svg/skills/gcp.svg'
import git from '../assets/svg/skills/git.svg'
import graphql from '../assets/svg/skills/graphql.svg'
import github from '../assets/svg/skills/github.svg'
import html from '../assets/svg/skills/html.svg'
import javascript from '../assets/svg/skills/javascript.svg'
import jquery from '../assets/svg/skills/jquery.svg'
import materialui from '../assets/svg/skills/materialui.svg'
import mongoDB from '../assets/svg/skills/mongoDB.svg'
import mysql from '../assets/svg/skills/mysql.svg'
import nextJS from '../assets/svg/skills/nextJS.svg'
import nodejs from '../assets/svg/skills/nodejs.svg'
import numpy from '../assets/svg/skills/numpy.svg'
import php from '../assets/svg/skills/php.svg'
import postgresql from '../assets/svg/skills/postgresql.svg'
import python from '../assets/svg/skills/python.svg'
import react from '../assets/svg/skills/react.svg'
import ruby from '../assets/svg/skills/ruby.svg'
import tensorflow from '../assets/svg/skills/tensorflow.svg'
import typescript from '../assets/svg/skills/typescript.svg'
import vitejs from '../assets/svg/skills/vitejs.svg'
import vue from '../assets/svg/skills/vue.svg'
import wordpress from '../assets/svg/skills/wordpress.svg'
import azure from '../assets/svg/skills/azure.svg'
import blender from '../assets/svg/skills/blender.svg'
import flutter from '../assets/svg/skills/flutter.svg'
import microsoftoffice from '../assets/svg/skills/microsoftoffice.svg'
import sqlite from '../assets/svg/skills/sqlite.svg'
import npm from '../assets/svg/skills/npm.svg'
import unity from '../assets/svg/skills/unity.svg'
import vscode from '../assets/svg/skills/vscode.svg'
import canva from '../assets/svg/skills/canva.svg'
import expressjs from '../assets/svg/skills/expressjs.svg'
import nestjs from '../assets/svg/skills/nestjs.svg'
import metaads from '../assets/svg/skills/metaads.svg'
import xads from '../assets/svg/skills/xads.svg'
import tiktokads from '../assets/svg/skills/tiktokads.svg'
import linkedinads from '../assets/svg/skills/linkedinads.svg'
import sublimetext from '../assets/svg/skills/sublimetext.svg'


export const skillsImage = (skill) => {
    const skillID = skill.toLowerCase();
    switch (skillID) {
        case 'gcp':
            return gcp;
        case 'html':
            return html;
        case 'github':
            return github;
        case 'docker':
            return docker;
        case 'css':
            return css;
        case 'sqlite':
                return sqlite;
        case 'javascript':
            return javascript;
        case 'next js':
            return nextJS;
        case 'react':
            return react;
        case 'typescript':
            return typescript;
        case 'vue':
            return vue;
        case 'bootstrap':
            return bootstrap;
        case 'mongodb':
            return mongoDB;
        case 'mysql':
            return mysql;
        case 'postgresql':
            return postgresql;
        case 'vite js':
            return vitejs;
        case 'c#':
            return csharp;
        case 'php':
            return php;
        case 'python':
            return python;
        case 'ruby':
            return ruby;
        case 'aws':
            return aws;
        case 'jquery':
            return jquery;
        case 'django':
            return django;
        case 'firebase':
            return firebase;
        case 'git':
            return git;
        case 'graphql':
            return graphql;
        case 'materialui':
            return materialui;
        case 'node js':
            return nodejs;
        case 'numpy':
            return numpy;
        case 'tensorflow':
            return tensorflow;
        case 'wordpress':
            return wordpress;
        case 'azure':
            return azure;
        case 'blender':
            return blender;
        case 'flutter':
            return flutter;
        case 'visual studio code':
            return vscode;
        case 'microsoft office':
            return microsoftoffice;
        case 'unity':
            return unity;
        case 'npm':
            return npm;
         case 'express js':
            return expressjs;
         case 'nest js':
            return nestjs;
        case 'canva':
            return canva;
             case 'x ads':
            return xads;
        case 'meta ads':
            return metaads;
        case 'tiktok ads':
            return tiktokads;
         case 'linkedin ads':
            return linkedinads;
         case 'sublime text':
            return sublimetext;
        default:
            break;
    }
}
